// Lehké kanály (úkol 3.6): stav propojení Telegramu, nový párovací kód a odpojení.
import type { TelegramPairing, TelegramStatus } from '@wac-buddy/shared'
import { api } from './client'

export function getTelegramStatus(): Promise<TelegramStatus> {
  return api('/me/channels/telegram')
}

/** Nový párovací kód a odkaz na bota. Vrací 409, když bot na serveru není nastavený. */
export function createTelegramPairing(): Promise<TelegramPairing> {
  return api('/me/channels/telegram/pairing', { method: 'POST' })
}

export function unlinkTelegram(): Promise<void> {
  return api('/me/channels/telegram', { method: 'DELETE' })
}
